import gql from "graphql-tag";
const PROCESS_DEVICE_IDS = gql`
  mutation processDeviceIds($emailListId: ID) {
    processDeviceIds(data: { emailListId: $emailListId })
  }
`;

export default PROCESS_DEVICE_IDS;
